/* gtm-kbw39bv4-boot + gt-k5l8rdft */
(function () {
  try {
    var GTM_ID = 'GTM-KBW39BV4';
    var GT_ID = 'GT-K5L8RDFT';
    window.dataLayer = window.dataLayer || [];
    function gtag(){ window.dataLayer.push(arguments); }
    window.gtag = window.gtag || gtag;

    if (!window.__merenloGtmBooted) {
      window.__merenloGtmBooted = true;
      if (document.documentElement.innerHTML.indexOf(GTM_ID) === -1) {
        window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
        var s = document.createElement('script');
        s.async = true;
        s.src = 'https://www.googletagmanager.com/gtm.js?id=' + GTM_ID;
        var f = document.getElementsByTagName('script')[0];
        if (f && f.parentNode) f.parentNode.insertBefore(s, f);
        else (document.head || document.documentElement).appendChild(s);
      }
    }

    if (!window.__merenloGtBooted) {
      window.__merenloGtBooted = true;
      if (document.documentElement.innerHTML.indexOf(GT_ID) === -1) {
        var g = document.createElement('script');
        g.async = true;
        g.src = 'https://www.googletagmanager.com/gtag/js?id=' + GT_ID;
        (document.head || document.documentElement).appendChild(g);
        gtag('js', new Date());
        gtag('config', GT_ID);
      }
    }
  } catch (e) {}
})();

(function () {
  'use strict';

  function toggleModal(modal, show) {
    if (!modal) return;
    modal.hidden = !show;
    document.body.style.overflow = show ? 'hidden' : '';
  }

  function initMenu() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var menu = document.querySelector('[data-mobile-menu]');
    if (!toggle || !menu) return;

    toggle.addEventListener('click', function () {
      var isOpen = !menu.hidden;
      toggleModal(menu, !isOpen);
      toggle.setAttribute('aria-expanded', String(!isOpen));
    });

    menu.querySelectorAll('[data-menu-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        toggleModal(menu, false);
        toggle.setAttribute('aria-expanded', 'false');
      });
    });
  }

  function initSearch() {
    var toggle = document.querySelector('[data-search-toggle]');
    var modal = document.querySelector('[data-search-modal]');
    if (!toggle || !modal) return;

    toggle.addEventListener('click', function () {
      var isOpen = !modal.hidden;
      toggleModal(modal, !isOpen);
      toggle.setAttribute('aria-expanded', String(!isOpen));
      if (!isOpen) {
        var input = modal.querySelector('input[type="search"]');
        if (input) input.focus();
      }
    });

    modal.querySelectorAll('[data-search-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        toggleModal(modal, false);
        toggle.setAttribute('aria-expanded', 'false');
      });
    });
  }

  function initGallery() {
    var gallery = document.querySelector('[data-pdp-gallery]') || document.querySelector('[data-product-gallery]');
    if (!gallery) return;

    var slides = gallery.querySelectorAll('[data-gallery-slide]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    var dots = gallery.querySelectorAll('[data-gallery-dot]');
    var currentIndex = 0;

    function getActiveIndex() {
      for (var i = 0; i < slides.length; i += 1) {
        if (slides[i].classList.contains('is-active')) return i;
      }
      return 0;
    }

    function activateSlide(index) {
      var next = String(index);
      currentIndex = Number(index) || 0;
      slides.forEach(function (slide) {
        slide.classList.toggle('is-active', slide.getAttribute('data-gallery-slide') === next);
      });
      thumbs.forEach(function (thumb) {
        thumb.classList.toggle('is-active', thumb.getAttribute('data-gallery-thumb') === next);
      });
      dots.forEach(function (dot) {
        dot.classList.toggle('is-active', dot.getAttribute('data-gallery-dot') === next);
      });
    }

    currentIndex = getActiveIndex();

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        activateSlide(thumb.getAttribute('data-gallery-thumb'));
      });
    });

    var prevBtn = gallery.querySelector('[data-gallery-prev]');
    var nextBtn = gallery.querySelector('[data-gallery-next]');
    if (prevBtn && slides.length > 1) {
      prevBtn.addEventListener('click', function () {
        var i = getActiveIndex();
        activateSlide(String(i === 0 ? slides.length - 1 : i - 1));
      });
    }
    if (nextBtn && slides.length > 1) {
      nextBtn.addEventListener('click', function () {
        var i = getActiveIndex();
        activateSlide(String(i === slides.length - 1 ? 0 : i + 1));
      });
    }

    var stage = gallery.querySelector('[data-pdp-gallery-stage]');
    if (stage && slides.length > 1 && window.matchMedia('(max-width: 749px)').matches) {
      var startX = 0;

      stage.addEventListener('touchstart', function (event) {
        startX = event.changedTouches[0].screenX;
      }, { passive: true });

      stage.addEventListener('touchend', function (event) {
        var diff = event.changedTouches[0].screenX - startX;
        if (Math.abs(diff) < 40) return;
        currentIndex = getActiveIndex();
        currentIndex = diff < 0
          ? Math.min(currentIndex + 1, slides.length - 1)
          : Math.max(currentIndex - 1, 0);
        activateSlide(String(currentIndex));
      }, { passive: true });
    }
  }

  function initSizeGuideModal() {
    var modal = document.querySelector('[data-size-guide-modal]');
    if (!modal) return;

    document.querySelectorAll('[data-size-guide-open]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        toggleModal(modal, true);
      });
    });

    modal.querySelectorAll('[data-size-guide-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        toggleModal(modal, false);
      });
    });
  }

  function getCartRoutes() {
    var routes = window.Merenlo && window.Merenlo.routes;
    return {
      root: (routes && routes.root) || '/',
      cartAdd: (routes && routes.cartAdd) || '/cart/add.js',
      cartJson: (routes && routes.cartJson) || '/cart.js',
      cartUrl: (routes && routes.cartUrl) || '/cart'
    };
  }

  function getShopifyRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return getCartRoutes().root || '/';
  }

  function productJsonUrl(handle) {
    var root = getShopifyRoot();
    if (!root) root = '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root + 'products/' + encodeURIComponent(handle) + '.js';
  }

  function updateCartCount(itemCount) {
    var count = typeof itemCount === 'number' ? itemCount : null;

    function applyCount(value) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = String(value);
      });
    }

    if (count !== null) {
      applyCount(count);
      return Promise.resolve(count);
    }

    return fetch(getCartRoutes().cartJson, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        applyCount(cart.item_count);
        return cart.item_count;
      })
      .catch(function () { return null; });
  }

  function showCartNotice(message) {
    var notice = document.querySelector('[data-cart-notice]');
    var textEl = document.querySelector('[data-cart-notice-text]');
    var linkEl = notice && notice.querySelector('[data-cart-notice-link]');
    if (!notice) return;

    if (textEl) textEl.textContent = message || 'Added to cart';
    if (linkEl && !linkEl.textContent) {
      linkEl.textContent = linkEl.dataset.defaultLabel || 'View cart';
    }
    notice.hidden = false;
    notice.classList.add('is-visible');

    clearTimeout(showCartNotice.timer);
    showCartNotice.timer = setTimeout(function () {
      hideCartNotice();
    }, 5000);
  }

  function hideCartNotice() {
    var notice = document.querySelector('[data-cart-notice]');
    var textEl = notice && notice.querySelector('[data-cart-notice-text]');
    if (!notice) return;
    notice.classList.remove('is-visible');
    notice.hidden = true;
    if (textEl) textEl.textContent = '';
  }

  function initCartNotice() {
    var notice = document.querySelector('[data-cart-notice]');
    if (!notice || notice.dataset.bound === 'true') return;

    notice.dataset.bound = 'true';
    notice.querySelectorAll('[data-cart-notice-close]').forEach(function (button) {
      button.addEventListener('click', hideCartNotice);
    });
  }

  function isCartDrawerEnabled() {
    return window.Merenlo && window.Merenlo.cartType === 'drawer';
  }

  function handleAddToCartSuccess(productTitle) {
    return updateCartCount().then(function () {
      if (isCartDrawerEnabled() && typeof window.Merenlo.openCartDrawer === 'function') {
        hideCartNotice();
        return window.Merenlo.openCartDrawer();
      }
      showCartNotice((productTitle || 'Product') + ' added to cart');
    });
  }

  function initCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer || drawer.dataset.bound === 'true') return;
    drawer.dataset.bound = 'true';

    var panel = drawer.querySelector('[data-cart-drawer-panel]');
    var lastFocusedElement = null;

    function setDrawerOpen(isOpen) {
      drawer.hidden = !isOpen;
      if (isOpen) {
        drawer.removeAttribute('inert');
        lastFocusedElement = document.activeElement;
        document.body.style.overflow = 'hidden';
        if (panel) {
          panel.setAttribute('tabindex', '-1');
          panel.focus({ preventScroll: true });
        }
      } else {
        drawer.setAttribute('inert', '');
        document.body.style.overflow = '';
        if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
          lastFocusedElement.focus({ preventScroll: true });
        }
      }

      document.querySelectorAll('[data-cart-drawer-open]').forEach(function (trigger) {
        trigger.setAttribute('aria-expanded', String(isOpen));
      });
    }

    function refreshCartDrawerContent() {
      var content = drawer.querySelector('[data-cart-drawer-content]');
      if (!content) return Promise.resolve();

      content.setAttribute('aria-busy', 'true');
      var url = getCartRoutes().cartUrl + '?section_id=cart-drawer';

      return fetch(url, { credentials: 'same-origin' })
        .then(function (response) { return response.text(); })
        .then(function (html) {
          var wrap = document.createElement('div');
          wrap.innerHTML = html;
          var nextContent = wrap.querySelector('[data-cart-drawer-content]');
          if (nextContent) {
            content.innerHTML = nextContent.innerHTML;
          }
        })
        .catch(function () { /* keep current content on failure */ })
        .finally(function () {
          content.removeAttribute('aria-busy');
        });
    }

    function openCartDrawer() {
      if (!isCartDrawerEnabled()) return Promise.resolve();
      return refreshCartDrawerContent().then(function () {
        setDrawerOpen(true);
      });
    }

    function closeCartDrawer() {
      setDrawerOpen(false);
    }

    function changeLineQuantity(lineKey, quantity) {
      var routes = window.Merenlo && window.Merenlo.routes;
      var changeUrl = (routes && routes.cartChange) || '/cart/change.js';

      return fetch(changeUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          id: lineKey,
          quantity: quantity
        })
      }).then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw data;
          return data;
        });
      });
    }

    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-cart-drawer-open]')) {
        event.preventDefault();
        openCartDrawer();
        return;
      }

      if (event.target.closest('[data-cart-drawer-close]') && drawer.contains(event.target)) {
        event.preventDefault();
        closeCartDrawer();
      }
    });

    drawer.addEventListener('click', function (event) {
      var removeButton = event.target.closest('[data-cart-drawer-remove]');
      if (!removeButton) return;

      event.preventDefault();
      var removeKey = removeButton.getAttribute('data-line-key');
      if (!removeKey) return;

      removeButton.disabled = true;
      changeLineQuantity(removeKey, 0)
        .then(function (cart) { return updateCartCount(cart.item_count); })
        .then(function () { return refreshCartDrawerContent(); })
        .catch(function () {
          removeButton.disabled = false;
        });
    });

    drawer.addEventListener('change', function (event) {
      var input = event.target.closest('[data-cart-drawer-qty]');
      if (!input) return;

      var lineKey = input.getAttribute('data-line-key');
      var quantity = parseInt(input.value, 10);
      if (!lineKey || isNaN(quantity)) return;

      input.disabled = true;
      changeLineQuantity(lineKey, quantity)
        .then(function (cart) { return updateCartCount(cart.item_count); })
        .then(function () { return refreshCartDrawerContent(); })
        .catch(function () {
          input.disabled = false;
        });
    });

    window.Merenlo.openCartDrawer = openCartDrawer;
    window.Merenlo.closeCartDrawer = closeCartDrawer;
    window.Merenlo.refreshCartDrawer = refreshCartDrawerContent;
  }

  function formatMoney(cents) {
    var format = window.Merenlo && window.Merenlo.moneyFormat;
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && format) {
      return window.Shopify.formatMoney(cents, format);
    }
    return '£' + (Number(cents) / 100).toFixed(2) + ' GBP';
  }

  function addItemToCart(variantId, quantity) {
    return fetch(getCartRoutes().cartAdd, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        items: [{
          id: Number(variantId),
          quantity: quantity
        }]
      })
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) throw data;
        return data;
      });
    });
  }

  var COLOR_SWATCH_FALLBACKS = {
    black: '#101820',
    white: '#F5F3EF',
    'off white': '#F5F3EF',
    'off-white': '#F5F3EF',
    cream: '#F5F3EF',
    ivory: '#F5F3EF',
    grey: '#8A8580',
    gray: '#8A8580',
    'light grey': '#B8B3AD',
    'light gray': '#B8B3AD',
    charcoal: '#4A4540',
    navy: '#1B2A41',
    'dark blue': '#1B2A41',
    blue: '#4A6FA5',
    'light blue': '#9DB4C8',
    brown: '#7A5C45',
    tan: '#C4A882',
    camel: '#C4A882',
    beige: '#D8CFC0',
    khaki: '#B8A88A',
    green: '#6B7F6B',
    olive: '#6B6B4A',
    sage: '#9CAF9C',
    red: '#8B3A3A',
    burgundy: '#7A263A',
    wine: '#722F37',
    'red violet': '#9B4D6A',
    pink: '#D4A5A5',
    blush: '#E8C4C4',
    rose: '#C99191',
    yellow: '#C9A227',
    mustard: '#C4A035',
    orange: '#C46A2E',
    rust: '#A0522D',
    purple: '#7B6B8E',
    lavender: '#B8A9C9'
  };

  function isColorOptionName(name) {
    var value = (name || '').toLowerCase();
    return value.indexOf('color') !== -1 || value.indexOf('colour') !== -1;
  }

  function getSwatchColor(valueName) {
    var key = (valueName || '').toLowerCase().trim();
    if (!key) return '#D8D3CC';

    if (COLOR_SWATCH_FALLBACKS[key]) return COLOR_SWATCH_FALLBACKS[key];

    var normalized = key.replace(/[-_]+/g, ' ').replace(/\s+/g, ' ').trim();
    if (COLOR_SWATCH_FALLBACKS[normalized]) return COLOR_SWATCH_FALLBACKS[normalized];

    if (normalized.indexOf('black') !== -1) return '#101820';
    if (normalized.indexOf('white') !== -1 || normalized.indexOf('cream') !== -1 || normalized.indexOf('ivory') !== -1) return '#F5F3EF';
    if (normalized.indexOf('charcoal') !== -1 || normalized.indexOf('dark grey') !== -1 || normalized.indexOf('dark gray') !== -1) return '#4A4540';
    if (normalized.indexOf('light grey') !== -1 || normalized.indexOf('light gray') !== -1) return '#B8B3AD';
    if (normalized.indexOf('grey') !== -1 || normalized.indexOf('gray') !== -1) return '#8A8580';
    if (normalized.indexOf('navy') !== -1) return '#1B2A41';
    if (normalized.indexOf('light blue') !== -1 || normalized.indexOf('sky blue') !== -1) return '#9DB4C8';
    if (normalized.indexOf('blue') !== -1) return '#4A6FA5';
    if (normalized.indexOf('burgundy') !== -1 || normalized.indexOf('maroon') !== -1 || normalized.indexOf('wine') !== -1) return '#7A263A';
    if (normalized.indexOf('red violet') !== -1 || normalized.indexOf('violet red') !== -1) return '#9B4D6A';
    if (normalized.indexOf('red') !== -1) return '#8B3A3A';
    if (normalized.indexOf('pink') !== -1 || normalized.indexOf('blush') !== -1 || normalized.indexOf('rose') !== -1) return '#D4A5A5';
    if (normalized.indexOf('brown') !== -1) return '#7A5C45';
    if (normalized.indexOf('tan') !== -1 || normalized.indexOf('camel') !== -1) return '#C4A882';
    if (normalized.indexOf('beige') !== -1) return '#D8CFC0';
    if (normalized.indexOf('khaki') !== -1) return '#B8A88A';
    if (normalized.indexOf('sage') !== -1) return '#9CAF9C';
    if (normalized.indexOf('green') !== -1 || normalized.indexOf('olive') !== -1) return '#6B7F6B';
    if (normalized.indexOf('yellow') !== -1 || normalized.indexOf('mustard') !== -1) return '#C9A227';
    if (normalized.indexOf('orange') !== -1 || normalized.indexOf('rust') !== -1) return '#C46A2E';
    if (normalized.indexOf('purple') !== -1 || normalized.indexOf('lavender') !== -1) return '#7B6B8E';

    return '#D8D3CC';
  }

  function renderVariantPriceHtml(variant) {
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      return '<div class="price price--on-sale">' +
        '<s class="price__compare">' + formatMoney(variant.compare_at_price) + '</s> ' +
        '<span class="price__sale">' + formatMoney(variant.price) + '</span></div>';
    }
    return '<div class="price"><span class="price__regular">' + formatMoney(variant.price) + '</span></div>';
  }

  function getVariantImageSrc(product, variant) {
    if (variant && variant.featured_image) {
      if (typeof variant.featured_image === 'string') return variant.featured_image;
      if (variant.featured_image.src) return variant.featured_image.src;
    }
    if (product.featured_image) {
      if (typeof product.featured_image === 'string') return product.featured_image;
      if (product.featured_image.src) return product.featured_image.src;
    }
    if (product.images && product.images.length) {
      var firstImage = product.images[0];
      if (typeof firstImage === 'string') return firstImage;
      if (firstImage.src) return firstImage.src;
    }
    return '';
  }

  function getVariantOptions(variant) {
    if (!variant) return [];
    if (variant.options && variant.options.length) return variant.options.slice();
    return [variant.option1, variant.option2, variant.option3].filter(function (value) {
      return value !== null && value !== undefined && value !== '';
    });
  }

  function findVariantByOptions(product, options) {
    if (!options || options.some(function (value) { return value === null || value === undefined; })) return null;
    return product.variants.find(function (variant) {
      var variantOptions = getVariantOptions(variant);
      return variantOptions.every(function (opt, index) {
        return opt === options[index];
      });
    }) || null;
  }

  function scoreVariantMatch(variant, preferred) {
    var score = 0;
    var variantOptions = getVariantOptions(variant);
    preferred.forEach(function (opt, index) {
      if (opt && variantOptions[index] === opt) score += 1;
    });
    if (variant.available) score += 10;
    return score;
  }

  function resolveProductVariant(product, preferred, colorIndex) {
    var exact = findVariantByOptions(product, preferred);
    if (exact && exact.available) {
      return { variant: exact, options: getVariantOptions(exact).slice() };
    }

    if (colorIndex !== -1 && preferred[colorIndex]) {
      var colorMatches = product.variants.filter(function (variant) {
        var variantOptions = getVariantOptions(variant);
        return variantOptions[colorIndex] === preferred[colorIndex];
      });
      if (colorMatches.length) {
        var availableColor = colorMatches.filter(function (variant) { return variant.available; });
        var colorPool = availableColor.length ? availableColor : colorMatches;
        colorPool.sort(function (a, b) {
          return scoreVariantMatch(b, preferred) - scoreVariantMatch(a, preferred);
        });
        var selected = colorPool[0];
        return { variant: selected, options: getVariantOptions(selected).slice() };
      }
    }

    var ranked = product.variants.slice().sort(function (a, b) {
      return scoreVariantMatch(b, preferred) - scoreVariantMatch(a, preferred);
    });
    var availableRanked = ranked.filter(function (variant) { return variant.available; });
    var pool = availableRanked.length ? availableRanked : ranked;
    if (!pool.length) return null;

    var fallback = pool[0];
    return { variant: fallback, options: getVariantOptions(fallback).slice() };
  }

  function getAvailableOptionValues(product, optionIndex, selectedOptions) {
    var values = {};
    product.variants.forEach(function (variant) {
      if (!variant.available) return;
      var variantOptions = getVariantOptions(variant);
      var matches = true;
      selectedOptions.forEach(function (selected, index) {
        if (index === optionIndex || selected === null) return;
        if (variantOptions[index] !== selected) matches = false;
      });
      if (matches) values[variantOptions[optionIndex]] = true;
    });
    return values;
  }

  function ensureValidOptionSelection(container) {
    container.querySelectorAll('[data-option-fieldset]').forEach(function (fieldset) {
      var checked = fieldset.querySelector('[data-option-input]:checked');
      if (checked && !checked.disabled) return;

      var availableInput = fieldset.querySelector('[data-option-input]:not(:disabled)');
      if (availableInput) availableInput.checked = true;
    });
  }

  function updateOptionAvailability(product, container, selectedOptions) {
    container.querySelectorAll('[data-option-fieldset]').forEach(function (fieldset) {
      var optionIndex = parseInt(fieldset.getAttribute('data-option-index'), 10) - 1;
      if (Number.isNaN(optionIndex)) return;

      var availableValues = getAvailableOptionValues(product, optionIndex, selectedOptions);

      fieldset.querySelectorAll('[data-option-input]').forEach(function (input) {
        var isAvailable = Boolean(availableValues[input.value]);
        var label = input.closest('.pdp-form__value, .pdp-form__swatch, .quick-add__value, .quick-add__swatch');
        input.disabled = !isAvailable;
        if (label) label.classList.toggle('is-disabled', !isAvailable);
      });
    });
  }

  function getColorOptionIndexFromContainer(container) {
    var fieldset = container.querySelector('[data-option-fieldset][data-is-color="true"]');
    if (!fieldset) return -1;
    return parseInt(fieldset.getAttribute('data-option-index'), 10) - 1;
  }

  function getSelectedOptionsFromContainer(container) {
    var options = [];
    container.querySelectorAll('[data-option-fieldset]').forEach(function (fieldset) {
      var checked = fieldset.querySelector('[data-option-input]:checked');
      options.push(checked ? checked.value : null);
    });
    return options;
  }

  function initQuickAdd() {
    var modal = document.querySelector('[data-quick-add-modal]');
    if (!modal || modal.dataset.bound === 'true') return;
    modal.dataset.bound = 'true';

    var dialog = modal.querySelector('.quick-add__dialog');
    var loadingEl = modal.querySelector('[data-quick-add-loading]');
    var contentEl = modal.querySelector('[data-quick-add-content]');
    var formEl = modal.querySelector('[data-quick-add-form]');
    var optionsEl = modal.querySelector('[data-quick-add-options]');
    var imageEl = modal.querySelector('[data-quick-add-image]');
    var titleEl = modal.querySelector('[data-quick-add-title]');
    var vendorEl = modal.querySelector('[data-quick-add-vendor]');
    var priceEl = modal.querySelector('[data-quick-add-price]');
    var quantityEl = modal.querySelector('[data-quick-add-quantity]');
    var submitEl = modal.querySelector('[data-quick-add-submit]');
    var viewLinkEl = modal.querySelector('[data-quick-add-view-link]');
    var shopName = modal.dataset.shopName || '';

    var activeProduct = null;
    var activeTrigger = null;
    var lastFocusedElement = null;
    var ignoreCloseUntil = 0;

    function hydrateModalCopy() {
      var quantityLabel = modal.querySelector('[data-quick-add-quantity-label]');
      var quantityRow = modal.querySelector('[data-quick-add-quantity-row]');
      if (quantityLabel) quantityLabel.textContent = 'Quantity';
      if (quantityRow) quantityRow.removeAttribute('aria-hidden');
      if (submitEl) {
        submitEl.textContent = submitEl.dataset.defaultLabel || 'Add to cart';
      }
      if (viewLinkEl) {
        viewLinkEl.textContent = viewLinkEl.dataset.defaultLabel || 'View product details';
      }
    }

    function resetModalCopy() {
      if (submitEl) submitEl.textContent = '';
      if (viewLinkEl) viewLinkEl.textContent = '';
      var quantityLabel = modal.querySelector('[data-quick-add-quantity-label]');
      var quantityRow = modal.querySelector('[data-quick-add-quantity-row]');
      if (quantityLabel) quantityLabel.textContent = '';
      if (quantityRow) quantityRow.setAttribute('aria-hidden', 'true');
    }

    function setModalOpen(isOpen) {
      modal.hidden = !isOpen;
      if (isOpen) {
        modal.removeAttribute('inert');
      } else {
        modal.setAttribute('inert', '');
        resetModalCopy();
        contentEl.setAttribute('aria-hidden', 'true');
        loadingEl.setAttribute('aria-hidden', 'true');
      }
      dialog.setAttribute('aria-hidden', String(!isOpen));
      document.body.style.overflow = isOpen ? 'hidden' : '';

      if (isOpen) {
        hydrateModalCopy();
        lastFocusedElement = document.activeElement;
        dialog.setAttribute('tabindex', '-1');
        dialog.focus({ preventScroll: true });
      } else if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
        lastFocusedElement.focus({ preventScroll: true });
      }
    }

    function showLoading() {
      loadingEl.hidden = false;
      loadingEl.removeAttribute('aria-hidden');
      contentEl.hidden = true;
      contentEl.setAttribute('aria-hidden', 'true');
      loadingEl.innerHTML = '<span class="quick-add__spinner" aria-hidden="true"></span><span class="visually-hidden">Loading</span>';
    }

    function showError(message) {
      loadingEl.hidden = false;
      contentEl.hidden = true;
      loadingEl.innerHTML = '<p class="quick-add__error">' + message + '</p>';
    }

    function showContent() {
      contentEl.hidden = false;
      contentEl.removeAttribute('aria-hidden');
      loadingEl.hidden = true;
      loadingEl.setAttribute('aria-hidden', 'true');
    }

    function getSelectedOptionsFromForm() {
      var options = [];
      optionsEl.querySelectorAll('[data-option-fieldset]').forEach(function (fieldset) {
        var checked = fieldset.querySelector('[data-option-input]:checked');
        options.push(checked ? checked.value : null);
      });
      return options;
    }

    function getColorOptionIndexFromForm() {
      var fieldset = optionsEl.querySelector('[data-option-fieldset][data-is-color="true"]');
      if (!fieldset) return -1;
      return parseInt(fieldset.getAttribute('data-option-index'), 10) - 1;
    }

    function syncOptionInputs(options) {
      optionsEl.querySelectorAll('[data-option-fieldset]').forEach(function (fieldset, index) {
        var value = options[index];
        if (!value) return;
        fieldset.querySelectorAll('[data-option-input]').forEach(function (input) {
          input.checked = input.value === value;
        });
      });
    }

    function updateOptionLabels() {
      optionsEl.querySelectorAll('[data-option-input]').forEach(function (input) {
        var label = input.closest('.quick-add__value, .quick-add__swatch');
        if (label) label.classList.toggle('is-selected', input.checked);

        if (input.checked) {
          var position = input.getAttribute('data-option-position');
          var currentEl = optionsEl.querySelector('[data-option-current="' + position + '"]');
          if (currentEl) currentEl.textContent = input.value;
        }
      });
    }

    function updateAvailability() {
      if (!activeProduct) return;
      var selected = getSelectedOptionsFromForm();

      optionsEl.querySelectorAll('[data-option-fieldset]').forEach(function (fieldset) {
        var optionIndex = parseInt(fieldset.getAttribute('data-option-index'), 10) - 1;
        if (Number.isNaN(optionIndex)) return;

        var availableValues = getAvailableOptionValues(activeProduct, optionIndex, selected);
        fieldset.querySelectorAll('[data-option-input]').forEach(function (input) {
          var isAvailable = Boolean(availableValues[input.value]);
          var label = input.closest('.quick-add__value, .quick-add__swatch');
          input.disabled = !isAvailable;
          if (label) label.classList.toggle('is-disabled', !isAvailable);
        });
      });
    }

    function updateQuickAddState(changedInput) {
      if (!activeProduct) return null;

      var colorIndex = getColorOptionIndexFromForm();

      if (changedInput && colorIndex !== -1 && imageEl) {
        var changedIndex = parseInt(changedInput.getAttribute('data-option-position'), 10) - 1;
        if (changedIndex === colorIndex) {
          var colorVariant = activeProduct.variants.find(function (variant) {
            return getVariantOptions(variant)[colorIndex] === changedInput.value;
          });
          var previewSrc = getVariantImageSrc(activeProduct, colorVariant);
          if (previewSrc) {
            imageEl.src = previewSrc;
            imageEl.alt = activeProduct.title;
          }
        }
      }

      updateOptionAvailability(activeProduct, optionsEl, getSelectedOptionsFromForm());
      ensureValidOptionSelection(optionsEl);

      var preferred = getSelectedOptionsFromForm();
      var resolved = resolveProductVariant(activeProduct, preferred, colorIndex);
      if (!resolved) {
        updateOptionLabels();
        if (submitEl) {
          submitEl.disabled = true;
          submitEl.textContent = 'Choose options';
        }
        return null;
      }

      if (resolved.options.some(function (opt, index) { return opt !== preferred[index]; })) {
        syncOptionInputs(resolved.options);
        updateOptionAvailability(activeProduct, optionsEl, resolved.options);
        ensureValidOptionSelection(optionsEl);
      }

      updateOptionLabels();

      if (priceEl) priceEl.innerHTML = renderVariantPriceHtml(resolved.variant);
      if (imageEl) {
        var imageSrc = getVariantImageSrc(activeProduct, resolved.variant);
        if (imageSrc) {
          imageEl.src = imageSrc;
          imageEl.alt = activeProduct.title;
        }
      }

      if (submitEl) {
        submitEl.disabled = !resolved.variant.available;
        submitEl.textContent = resolved.variant.available ? 'Add to cart' : 'Sold out';
      }

      return resolved.variant;
    }

    function buildOptionValues(product, optionIndex) {
      var values = [];
      product.variants.forEach(function (variant) {
        var value = getVariantOptions(variant)[optionIndex];
        if (value && values.indexOf(value) === -1) values.push(value);
      });
      return values;
    }

    function renderOptions(product) {
      optionsEl.innerHTML = '';

      var initialVariant = product.variants.find(function (variant) { return variant.available; }) || product.variants[0];
      var initialOptions = getVariantOptions(initialVariant);

      (product.options || []).forEach(function (optionName, optionIndex) {
        var isColor = isColorOptionName(optionName);
        var values = buildOptionValues(product, optionIndex);
        var fieldset = document.createElement('fieldset');
        fieldset.className = 'quick-add__option';
        fieldset.setAttribute('data-option-fieldset', '');
        fieldset.setAttribute('data-option-index', String(optionIndex + 1));
        if (isColor) fieldset.setAttribute('data-is-color', 'true');

        var legend = document.createElement('legend');
        legend.className = 'quick-add__option-label';
        legend.innerHTML = '<span class="quick-add__option-name">' + optionName + '</span>';
        if (isColor) {
          legend.innerHTML += '<span class="quick-add__option-current" data-option-current="' + (optionIndex + 1) + '"></span>';
        }
        fieldset.appendChild(legend);

        var valuesWrap = document.createElement('div');
        valuesWrap.className = 'quick-add__option-values' + (isColor ? ' quick-add__option-values--swatches' : '');

        values.forEach(function (valueName, valueIndex) {
          var id = 'QuickAddOption-' + optionIndex + '-' + valueIndex;
          var label = document.createElement('label');
          label.className = isColor ? 'quick-add__swatch' : 'quick-add__value';

          var input = document.createElement('input');
          input.type = 'radio';
          input.name = 'quick-add-option-' + optionIndex;
          input.value = valueName;
          input.id = id;
          input.setAttribute('data-option-input', '');
          input.setAttribute('data-option-position', String(optionIndex + 1));
          if (initialOptions[optionIndex] === valueName) input.checked = true;

          label.appendChild(input);

          if (isColor) {
            var chip = document.createElement('span');
            chip.className = 'quick-add__swatch-chip';
            chip.style.setProperty('--swatch-bg', getSwatchColor(valueName));
            label.appendChild(chip);
            var hidden = document.createElement('span');
            hidden.className = 'visually-hidden';
            hidden.textContent = valueName;
            label.appendChild(hidden);
          } else {
            var text = document.createElement('span');
            text.textContent = valueName;
            label.appendChild(text);
          }

          input.addEventListener('change', function () {
            updateQuickAddState(input);
          });

          valuesWrap.appendChild(label);
        });

        fieldset.appendChild(valuesWrap);
        optionsEl.appendChild(fieldset);
      });
    }

    function normalizeName(value) {
      return String(value || '').trim().toLowerCase();
    }

    function populateModal(product) {
      activeProduct = product;
      titleEl.textContent = product.title;

      if (product.vendor && normalizeName(product.vendor) !== normalizeName(shopName)) {
        vendorEl.textContent = product.vendor;
        vendorEl.hidden = false;
      } else {
        vendorEl.hidden = true;
      }

      if (viewLinkEl) viewLinkEl.href = getShopifyRoot() + 'products/' + product.handle;
      if (quantityEl) quantityEl.value = '1';

      renderOptions(product);
      updateQuickAddState();
    }

    function fetchProduct(handle) {
      return fetch(productJsonUrl(handle), {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      }).then(function (response) {
        return response.text().then(function (text) {
          if (!response.ok) throw new Error('Product not found');
          try {
            return JSON.parse(text);
          } catch (error) {
            throw new Error('Invalid product data');
          }
        });
      });
    }

    function readEmbeddedProduct(trigger) {
      var card = trigger.closest('.product-card');
      if (!card) return null;

      var jsonEl = card.querySelector('[data-quick-add-json]');
      if (!jsonEl) return null;

      try {
        return JSON.parse(jsonEl.textContent);
      } catch (error) {
        return null;
      }
    }

    function openModalWithProduct(product) {
      ignoreCloseUntil = Date.now() + 500;
      setModalOpen(true);

      if (!product || !product.variants || !product.variants.length) {
        showError('This product is unavailable.');
        return;
      }

      populateModal(product);
      showContent();
    }

    function openModal(handle, trigger) {
      var embedded = trigger ? readEmbeddedProduct(trigger) : null;
      if (embedded) {
        openModalWithProduct(embedded);
        return Promise.resolve(embedded);
      }

      ignoreCloseUntil = Date.now() + 500;
      setModalOpen(true);
      showLoading();

      return fetchProduct(handle).then(function (product) {
        if (!product || !product.variants || !product.variants.length) {
          throw new Error('Product unavailable');
        }
        populateModal(product);
        showContent();
        return product;
      }).catch(function () {
        showError('Could not load product options. Close and try again.');
        showCartNotice('Could not load product options.');
      });
    }

    function closeModal() {
      if (Date.now() < ignoreCloseUntil) return;
      setModalOpen(false);
      activeProduct = null;
      activeTrigger = null;
      optionsEl.innerHTML = '';
      showLoading();
    }

    function handleQuickAddTrigger(trigger) {
      if (!trigger || trigger.disabled) return;

      var handle = trigger.getAttribute('data-product-handle');
      var hasVariants = trigger.getAttribute('data-has-variants') === 'true';
      var variantId = trigger.getAttribute('data-variant-id');
      var productTitle = trigger.getAttribute('data-product-title') || '';

      if (!hasVariants) {
        if (variantId) {
          handleDirectAdd(trigger, variantId, productTitle);
          return;
        }

        fetchProduct(handle).then(function (product) {
          var variant = product.variants.find(function (entry) { return entry.available; }) || product.variants[0];
          if (!variant || !variant.available) {
            showCartNotice('This product is sold out.');
            return;
          }
          handleDirectAdd(trigger, variant.id, product.title || productTitle);
        }).catch(function () {
          showCartNotice('Could not add to cart.');
        });
        return;
      }

      activeTrigger = trigger;
      openModal(handle, trigger);
    }

    function bindQuickAddTriggers() {
      document.querySelectorAll('[data-quick-add-trigger]').forEach(function (trigger) {
        if (trigger.dataset.quickAddBound === 'true') return;
        trigger.dataset.quickAddBound = 'true';

        trigger.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          handleQuickAddTrigger(trigger);
        });
      });
    }

    bindQuickAddTriggers();

    function setTriggerLoading(trigger, isLoading) {
      if (!trigger) return;
      trigger.classList.toggle('is-loading', isLoading);
      trigger.disabled = isLoading || trigger.getAttribute('data-has-available') === 'false';
    }

    function handleDirectAdd(trigger, variantId, productTitle) {
      setTriggerLoading(trigger, true);

      addItemToCart(variantId, 1)
        .then(function () { return handleAddToCartSuccess(productTitle || 'Product'); })
        .catch(function (error) {
          showCartNotice((error && error.description) || 'Could not add to cart.');
        })
        .finally(function () {
          setTriggerLoading(trigger, false);
        });
    }

    modal.querySelectorAll('[data-quick-add-close]').forEach(function (el) {
      el.addEventListener('click', function (event) {
        if (Date.now() < ignoreCloseUntil) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }
        closeModal();
      });
    });

    if (formEl) {
      formEl.addEventListener('submit', function (event) {
        event.preventDefault();
        if (!activeProduct) return;

        var variant = updateQuickAddState();
        if (!variant || !variant.available) return;

        var quantity = quantityEl ? parseInt(quantityEl.value, 10) : 1;
        if (!quantity || quantity < 1) quantity = 1;

        submitEl.disabled = true;
        submitEl.textContent = 'Adding…';
        submitEl.classList.add('is-loading');

        addItemToCart(variant.id, quantity)
          .then(function () { return handleAddToCartSuccess(activeProduct.title); })
          .then(function () {
            closeModal();
          })
          .catch(function (error) {
            showCartNotice((error && error.description) || 'Could not add to cart.');
          })
          .finally(function () {
            submitEl.classList.remove('is-loading');
            updateQuickAddState();
          });
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) closeModal();
    });

    document.addEventListener('shopify:section:load', bindQuickAddTriggers);
  }

  function initProductForm() {
    var section = document.querySelector('[data-product-section]');
    if (!section || section.dataset.productFormBound === 'true') return;

    var jsonEl = section.querySelector('[data-product-json]') || document.querySelector('[data-product-json]');
    var form = section.querySelector('[data-product-form], form.pdp-form');
    if (!jsonEl || !form) return;

    section.dataset.productFormBound = 'true';

    var product = JSON.parse(jsonEl.textContent);
    var variantInput = form.querySelector('[data-variant-id]');
    var addBtn = form.querySelector('[data-add-to-cart]');
    var priceEl = section.querySelector('[data-product-price]');
    var stickyPriceEl = section.querySelector('[data-sticky-price]');
    var stickyVariantEl = section.querySelector('[data-sticky-variant]');
    var stickyBtn = section.querySelector('[data-sticky-atc-btn]');
    var gallery = section.querySelector('[data-pdp-gallery]');

    function getColorOptionIndex() {
      var fieldset = form.querySelector('[data-option-fieldset][data-is-color="true"]');
      if (!fieldset) return -1;
      return parseInt(fieldset.getAttribute('data-option-index'), 10) - 1;
    }

    function getSelectedOptions() {
      var fieldsets = Array.prototype.slice.call(form.querySelectorAll('[data-option-fieldset]'));
      fieldsets.sort(function (a, b) {
        return parseInt(a.getAttribute('data-option-index'), 10) - parseInt(b.getAttribute('data-option-index'), 10);
      });

      return fieldsets.map(function (fieldset) {
        var checked = fieldset.querySelector('[data-option-input]:checked');
        return checked ? checked.value : null;
      });
    }

    function syncInputsToOptions(options) {
      var fieldsets = Array.prototype.slice.call(form.querySelectorAll('[data-option-fieldset]'));
      fieldsets.sort(function (a, b) {
        return parseInt(a.getAttribute('data-option-index'), 10) - parseInt(b.getAttribute('data-option-index'), 10);
      });

      fieldsets.forEach(function (fieldset, index) {
        var value = options[index];
        if (!value) return;

        fieldset.querySelectorAll('[data-option-input]').forEach(function (input) {
          input.checked = input.value === value;
        });
      });
    }

    function findVariantWithOptions(options) {
      if (options.some(function (value) { return value === null; })) return null;

      return product.variants.find(function (variant) {
        return variant.options.every(function (opt, index) {
          return opt === options[index];
        });
      }) || null;
    }

    function resolveSelection(preferred) {
      if (!form.querySelector('[data-option-fieldset]')) {
        var fallbackVariant = product.variants.find(function (variant) { return variant.available; }) || product.variants[0];
        return fallbackVariant ? { variant: fallbackVariant, options: getVariantOptions(fallbackVariant).slice() } : null;
      }

      return resolveProductVariant(product, preferred, getColorOptionIndex());
    }

    function updateAvailability() {
      updateOptionAvailability(product, form, getSelectedOptions());
      ensureValidOptionSelection(form);
    }

    function renderPrice(variant) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        return '<div class="price price--on-sale" data-price-root>' +
          '<s class="price__compare">' + formatMoney(variant.compare_at_price) + '</s> ' +
          '<span class="price__sale">' + formatMoney(variant.price) + '</span>' +
          '<span class="price__badge" data-sale-badge>Sale</span></div>';
      }
      return '<div class="price" data-price-root><span class="price__regular">' + formatMoney(variant.price) + '</span></div>';
    }

    function activateGallerySlide(index) {
      if (!gallery || index === null || index === undefined) return;

      var indexStr = String(index);
      var slides = gallery.querySelectorAll('[data-gallery-slide]');
      var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
      var dots = gallery.querySelectorAll('[data-gallery-dot]');

      slides.forEach(function (slide) {
        slide.classList.toggle('is-active', slide.getAttribute('data-gallery-slide') === indexStr);
      });
      thumbs.forEach(function (thumb) {
        thumb.classList.toggle('is-active', thumb.getAttribute('data-gallery-thumb') === indexStr);
      });
      dots.forEach(function (dot) {
        dot.classList.toggle('is-active', dot.getAttribute('data-gallery-dot') === indexStr);
      });
    }

    function getVariantMediaId(variant) {
      if (!variant) return null;
      if (variant.featured_media && variant.featured_media.id) return variant.featured_media.id;
      if (variant.featured_image && variant.featured_image.id) return variant.featured_image.id;
      return null;
    }

    function activateGalleryByMediaId(mediaId) {
      if (!gallery || !mediaId) return false;

      var slide = gallery.querySelector('[data-media-id="' + mediaId + '"]');
      if (!slide) return false;

      activateGallerySlide(slide.getAttribute('data-gallery-slide'));
      return true;
    }

    function normalizeColorValue(value) {
      return (value || '').toLowerCase().replace(/\s+/g, ' ').trim();
    }

    function activateGalleryForColorValue(colorValue) {
      if (!gallery || !colorValue) return false;

      var colorLower = normalizeColorValue(colorValue);
      var slides = gallery.querySelectorAll('[data-gallery-slide]');
      var matchedSlide = null;

      slides.forEach(function (slide) {
        if (matchedSlide) return;

        var linkedColors = slide.getAttribute('data-color-values');
        if (linkedColors) {
          linkedColors.split('|').some(function (color) {
            if (color && normalizeColorValue(color) === colorLower) {
              matchedSlide = slide;
              return true;
            }
            return false;
          });
        }
      });

      if (matchedSlide) {
        activateGallerySlide(matchedSlide.getAttribute('data-gallery-slide'));
        return true;
      }

      slides.forEach(function (slide) {
        if (matchedSlide) return;

        var img = slide.querySelector('img');
        if (!img) return;

        var alt = normalizeColorValue(img.getAttribute('alt') || '');
        var titleLower = normalizeColorValue(product.title || '');
        if (!alt || alt === titleLower) return;

        if (alt === colorLower || alt.indexOf(colorLower) !== -1 || colorLower.indexOf(alt) !== -1) {
          matchedSlide = slide;
        }
      });

      if (matchedSlide) {
        activateGallerySlide(matchedSlide.getAttribute('data-gallery-slide'));
        return true;
      }

      var colorIndex = getColorOptionIndex();
      if (colorIndex === -1) return false;

      for (var i = 0; i < product.variants.length; i += 1) {
        var variant = product.variants[i];
        var variantColor = getVariantOptions(variant)[colorIndex];
        if (normalizeColorValue(variantColor) !== colorLower) continue;
        if (activateGalleryByMediaId(getVariantMediaId(variant))) return true;
      }

      return false;
    }

    function updateSelectedLabels() {
      form.querySelectorAll('[data-option-input]').forEach(function (input) {
        var label = input.closest('.pdp-form__value, .pdp-form__swatch');
        if (label) label.classList.toggle('is-selected', input.checked);

        if (input.checked) {
          var position = input.getAttribute('data-option-position');
          var currentEl = form.querySelector('[data-option-current="' + position + '"]');
          if (currentEl) currentEl.textContent = input.value;
        }
      });
    }

    function applyVariant(variant) {
      if (variantInput) variantInput.value = String(variant.id);

      var labelText = variant.available ? 'Add to cart' : 'Sold out';
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = labelText;
        addBtn.setAttribute('aria-disabled', String(!variant.available));
      }
      if (stickyBtn) {
        stickyBtn.disabled = !variant.available;
        stickyBtn.textContent = labelText;
        stickyBtn.setAttribute('aria-disabled', String(!variant.available));
      }

      var priceHtml = renderPrice(variant);
      if (priceEl) priceEl.innerHTML = priceHtml;
      if (stickyPriceEl) stickyPriceEl.innerHTML = priceHtml;
      if (stickyVariantEl && !product.has_only_default_variant) {
        stickyVariantEl.textContent = variant.title;
      }
    }

    function ensureResolvedVariant() {
      var resolved = resolveSelection(getSelectedOptions());
      if (!resolved) return null;

      syncInputsToOptions(resolved.options);
      applyVariant(resolved.variant);
      updateSelectedLabels();
      updateAvailability();
      return resolved.variant;
    }

    function setSubmitLoading(isLoading) {
      [addBtn, stickyBtn].forEach(function (button) {
        if (!button || button.disabled) return;
        button.dataset.defaultLabel = button.dataset.defaultLabel || button.textContent;
        button.textContent = isLoading ? 'Adding…' : button.dataset.defaultLabel;
        button.classList.toggle('is-loading', isLoading);
      });
    }

    function updateVariant(changedInput) {
      var colorIndex = getColorOptionIndex();

      if (changedInput && colorIndex !== -1) {
        var changedIndex = parseInt(changedInput.getAttribute('data-option-position'), 10) - 1;
        if (changedIndex === colorIndex) {
          activateGalleryForColorValue(changedInput.value);
        }
      }

      updateAvailability();

      var preferred = getSelectedOptions();
      var resolved = resolveSelection(preferred);
      if (!resolved) {
        updateSelectedLabels();
        return;
      }

      if (resolved.options.some(function (opt, index) { return opt !== preferred[index]; })) {
        syncInputsToOptions(resolved.options);
        updateAvailability();
      }

      updateSelectedLabels();
      applyVariant(resolved.variant);

      if (colorIndex !== -1) {
        activateGalleryForColorValue(getVariantOptions(resolved.variant)[colorIndex]);
      } else {
        activateGalleryByMediaId(getVariantMediaId(resolved.variant));
      }
    }

    form.querySelectorAll('[data-option-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        updateVariant(input);
      });
    });

    form.querySelectorAll('.pdp-form__swatch, .pdp-form__value').forEach(function (label) {
      label.addEventListener('click', function () {
        var input = label.querySelector('[data-option-input]');
        if (!input || input.disabled) return;
        if (!input.checked) {
          input.checked = true;
          updateVariant(input);
        }
      });
    });

    if (form.dataset.cartBound !== 'true') {
      form.dataset.cartBound = 'true';

      form.addEventListener('submit', function (event) {
        event.preventDefault();

        var variant = ensureResolvedVariant();
        if (!variant || !variant.available) return;

        var quantityInput = form.querySelector('[name="quantity"]');
        var quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;
        if (!quantity || quantity < 1) quantity = 1;

        setSubmitLoading(true);

        addItemToCart(variant.id, quantity)
          .then(function () {
            return handleAddToCartSuccess(product.title);
          })
          .catch(function (error) {
            var message = (error && (error.description || error.message)) || 'Could not add this item to cart.';
            showCartNotice(message);
          })
          .finally(function () {
            setSubmitLoading(false);
            updateVariant();
          });
      });
    }

    updateVariant();
  }

  function initStickyAtc() {
    var sticky = document.querySelector('[data-sticky-atc]');
    var submit = document.querySelector('.pdp-form__submit') || document.querySelector('.product-form__submit');
    if (!sticky || !submit) return;

    if (window.matchMedia('(min-width: 750px)').matches) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        sticky.hidden = entry.isIntersecting;
      });
    }, { threshold: 0 });

    observer.observe(submit);
    sticky.hidden = true;
  }

  function initCategoryNav() {
    var nav = document.querySelector('.category-orven__nav');
    if (!nav) return;

    var mq = window.matchMedia('(min-width: 900px)');
    var items = nav.querySelectorAll('[data-category-item]');

    function setOpen(item) {
      items.forEach(function (entry) {
        entry.classList.remove('is-open');
        var trigger = entry.querySelector('[data-category-link]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        entry.querySelectorAll('.category-orven__children__item').forEach(function (child) {
          child.style.removeProperty('transition-delay');
        });
      });
      if (!item) return;
      item.classList.add('is-open');
      var activeTrigger = item.querySelector('[data-category-link]');
      if (activeTrigger) activeTrigger.setAttribute('aria-expanded', 'true');
    }

    items.forEach(function (item) {
      item.addEventListener('pointerenter', function () {
        if (!mq.matches) return;
        setOpen(item);
      });

      item.addEventListener('click', function (event) {
        if (mq.matches) {
          if (event.target.closest('.category-orven__children__link')) return;
          var parentLink = event.target.closest('a.category-orven__link');
          if (parentLink && item.classList.contains('is-open')) return;
          if (parentLink) event.preventDefault();
          if (item.classList.contains('is-open')) {
            setOpen(null);
            return;
          }
          setOpen(item);
          return;
        }

        if (event.target.closest('.category-orven__children__link')) return;

        var mobileLink = event.target.closest('a.category-orven__link');
        if (mobileLink && item.classList.contains('is-open')) return;

        if (mobileLink) event.preventDefault();

        if (item.classList.contains('is-open')) {
          setOpen(null);
          return;
        }

        setOpen(item);
      });
    });

    document.addEventListener('pointerdown', function (event) {
      if (!mq.matches || nav.contains(event.target)) return;
      setOpen(null);
    });
  }

  var scrollRevealObserver;

  function initScrollReveal() {
    var sections = document.querySelectorAll(
      '.shopify-section:not(.section-header):not(.section-announcement):not(.section-hero):not(.scroll-reveal)'
    );

    if (!sections.length) return;

    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReduced) {
      sections.forEach(function (section) {
        section.classList.add('scroll-reveal', 'is-revealed');
      });
      return;
    }

    if (!scrollRevealObserver) {
      scrollRevealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          scrollRevealObserver.unobserve(entry.target);
        });
      }, {
        threshold: 0.08,
        rootMargin: '0px 0px -4% 0px'
      });
    }

    var revealOffset = window.matchMedia('(max-width: 749px)').matches ? 0.92 : 0.85;

    sections.forEach(function (section) {
      section.classList.add('scroll-reveal');
      var rect = section.getBoundingClientRect();
      if (rect.top < window.innerHeight * revealOffset) {
        section.classList.add('is-revealed');
        return;
      }
      scrollRevealObserver.observe(section);
    });
  }

  function initModalEscape() {
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;

      var menu = document.querySelector('[data-mobile-menu]');
      var search = document.querySelector('[data-search-modal]');
      var toggle = document.querySelector('[data-menu-toggle]');
      var searchToggle = document.querySelector('[data-search-toggle]');

      if (menu && !menu.hidden) {
        toggleModal(menu, false);
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      }

      if (search && !search.hidden) {
        toggleModal(search, false);
        if (searchToggle) searchToggle.setAttribute('aria-expanded', 'false');
      }

      var sizeGuide = document.querySelector('[data-size-guide-modal]');
      if (sizeGuide && !sizeGuide.hidden) {
        toggleModal(sizeGuide, false);
      }

      var cartDrawer = document.querySelector('[data-cart-drawer]');
      if (cartDrawer && !cartDrawer.hidden && typeof window.Merenlo.closeCartDrawer === 'function') {
        window.Merenlo.closeCartDrawer();
      }
    });
  }

  function initHeaderScroll() {
    var header = document.querySelector('[data-header]');
    if (!header) return;

    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 6);
    };

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function initFeaturedSlider() {
    document.querySelectorAll('[data-featured-slider]').forEach(function (slider) {
      if (slider.dataset.featuredSliderReady === 'true') return;
      slider.dataset.featuredSliderReady = 'true';

      var track = slider.querySelector('[data-featured-slider-track]');
      var prev = slider.querySelector('[data-featured-slider-prev]');
      var next = slider.querySelector('[data-featured-slider-next]');
      var counter = slider.querySelector('[data-featured-slider-counter]');
      if (!track) return;

      function getGap() {
        return parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap || 0) || 0;
      }

      function getSlideWidth() {
        var slide = track.querySelector('.featured-orven__slide, .retail-seasonal__slide');
        return slide ? slide.offsetWidth + getGap() : track.clientWidth;
      }

      function getSlidesPerPage() {
        var slideWidth = getSlideWidth();
        if (!slideWidth) return 1;
        return Math.max(1, Math.floor((track.clientWidth + getGap()) / slideWidth));
      }

      function getTotalPages() {
        var slides = track.querySelectorAll('.featured-orven__slide, .retail-seasonal__slide').length;
        return Math.max(1, Math.ceil(slides / getSlidesPerPage()));
      }

      function getCurrentPage() {
        var slideWidth = getSlideWidth();
        var perPage = getSlidesPerPage();
        if (!slideWidth) return 0;
        return Math.min(
          getTotalPages() - 1,
          Math.round(track.scrollLeft / (slideWidth * perPage))
        );
      }

      function updateUI() {
        var page = getCurrentPage() + 1;
        var total = getTotalPages();
        if (counter) counter.textContent = page + ' / ' + total;
        if (prev) prev.disabled = page <= 1;
        if (next) next.disabled = page >= total;
      }

      function scrollToPage(pageIndex) {
        var slideWidth = getSlideWidth();
        var perPage = getSlidesPerPage();
        var target = Math.max(0, pageIndex) * slideWidth * perPage;
        track.scrollTo({ left: target, behavior: 'smooth' });
      }

      if (prev) {
        prev.addEventListener('click', function () {
          scrollToPage(getCurrentPage() - 1);
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          scrollToPage(getCurrentPage() + 1);
        });
      }

      track.addEventListener('scroll', updateUI, { passive: true });
      window.addEventListener('resize', updateUI);
      updateUI();
    });
  }

  function initHeaderNav() {
    var mq = window.matchMedia('(min-width: 750px)');
    var navs = document.querySelectorAll('.retail-header .header-nav, .site-header .header-nav, .mobile-nav');
    var closeTimer = null;

    function cancelClose() {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
    }

    function closeDesktopDetails(except) {
      document.querySelectorAll('.header-nav [data-nav-details]').forEach(function (entry) {
        if (entry === except) return;
        entry.open = false;
        entry.classList.remove('is-hover');
      });
    }

    navs.forEach(function (nav) {
      var detailsList = nav.querySelectorAll('[data-nav-details]');

      detailsList.forEach(function (details) {
        if (details.dataset.navReady === 'true') return;
        details.dataset.navReady = 'true';

        var hoverTarget = details.closest('.header-nav__item--has-children') || details;

        details.addEventListener('toggle', function () {
          if (!details.open) {
            details.classList.remove('is-hover');
            return;
          }

          detailsList.forEach(function (other) {
            if (other !== details) other.open = false;
          });
        });

        function openDesktopDetails() {
          if (!mq.matches || !nav.classList.contains('header-nav')) return;
          cancelClose();
          closeDesktopDetails(details);
          details.open = true;
          details.classList.add('is-hover');
        }

        function scheduleCloseDesktopDetails() {
          if (!mq.matches || !nav.classList.contains('header-nav')) return;
          cancelClose();
          closeTimer = setTimeout(function () {
            details.open = false;
            details.classList.remove('is-hover');
          }, 220);
        }

        hoverTarget.addEventListener('mouseenter', openDesktopDetails);

        hoverTarget.addEventListener('mouseleave', function (event) {
          if (!mq.matches || !nav.classList.contains('header-nav')) return;
          var next = event.relatedTarget;
          if (next && hoverTarget.contains(next)) return;
          scheduleCloseDesktopDetails();
        });

        details.addEventListener('focusin', openDesktopDetails);

        details.addEventListener('focusout', function (event) {
          if (!mq.matches || !nav.classList.contains('header-nav')) return;
          var next = event.relatedTarget;
          if (next && hoverTarget.contains(next)) return;
          scheduleCloseDesktopDetails();
        });
      });
    });

    if (!document.documentElement.dataset.navOutsideBound) {
      document.documentElement.dataset.navOutsideBound = 'true';

      document.addEventListener('click', function (event) {
        if (!mq.matches) return;
        var openDetails = document.querySelector('.header-nav [data-nav-details][open]');
        if (!openDetails || openDetails.contains(event.target)) return;
        closeDesktopDetails();
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') closeDesktopDetails();
      });
    }
  }

  function loadConsentTrackingApi(callback) {
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      callback(null);
      return;
    }

    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
      callback(new Error('Shopify.loadFeatures unavailable'));
      return;
    }

    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) {
        callback(error || null);
      }
    );
  }

  function tryOpenPandectesBanner() {
    var cmp = document.querySelector('pandectes-cmp');
    if (!cmp || !cmp.shadowRoot) return false;

    // Built-in floating widget reopens the consent notice (works even when
    // Pandectes "Custom open/reopen" / customTrigger is disabled).
    var widgetBtn =
      cmp.shadowRoot.querySelector('button.widget') ||
      cmp.shadowRoot.querySelector('button[aria-label="Change your consent"]') ||
      cmp.shadowRoot.querySelector('button[aria-label*="consent" i]');
    if (widgetBtn) {
      widgetBtn.click();
      return true;
    }

    return false;
  }

  function tryShowCookiePreferences() {
    // Pandectes GDPR Cookie Consent (current storefront CMP).
    if (document.querySelector('pandectes-cmp') || window.PandectesCore || window.pandectesBannerSettings) {
      try {
        if (tryOpenPandectesBanner()) return true;

        // Official hash reopen (requires Pandectes → Banner → Advanced → Custom open/reopen).
        if (window.location.hash === '#reopenBanner') {
          window.dispatchEvent(new HashChangeEvent('hashchange'));
        } else {
          window.location.hash = 'reopenBanner';
        }
        // Hash alone may be a no-op when customTrigger is false; still try widget again.
        if (tryOpenPandectesBanner()) return true;
        return Boolean(document.querySelector('pandectes-cmp'));
      } catch (error) {
        /* continue to fallbacks */
      }
    }

    // Native Shopify cookie banner preference modal (storefront-banner.js).
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      try {
        var result = window.privacyBanner.showPreferences();
        if (result && typeof result.then === 'function') {
          result.catch(function () {});
        }
        return true;
      } catch (error) {
        /* continue to fallbacks */
      }
    }

    // Legacy Customer Privacy API path (when available).
    if (
      window.Shopify &&
      window.Shopify.customerPrivacy &&
      typeof window.Shopify.customerPrivacy.showPreferences === 'function'
    ) {
      window.Shopify.customerPrivacy.showPreferences();
      return true;
    }

    return false;
  }

  function openCookiePreferences() {
    if (tryShowCookiePreferences()) return;

    loadConsentTrackingApi(function () {
      if (tryShowCookiePreferences()) return;

      // CMP scripts inject asynchronously (Pandectes / Shopify privacy banner).
      var attempts = 0;
      var timer = window.setInterval(function () {
        attempts += 1;
        if (tryShowCookiePreferences() || attempts >= 40) {
          window.clearInterval(timer);
          if (attempts >= 40 && !tryShowCookiePreferences()) {
            window.location.hash = 'reopenBanner';
          }
        }
      }, 150);
    });
  }

  function initCookiePreferences() {
    loadConsentTrackingApi(function () {});

    document.querySelectorAll('[data-cookie-preferences]').forEach(function (trigger) {
      if (trigger.getAttribute('data-cookie-preferences-bound') === 'true') return;
      trigger.setAttribute('data-cookie-preferences-bound', 'true');
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        openCookiePreferences();
      });
    });
  }

  function initContactForm() {
    var form = document.getElementById('ContactForm');
    if (!form) return;

    form.addEventListener('submit', function () {
      var body = form.querySelector('[data-contact-body]');
      var orderNumber = form.querySelector('[name="contact[order_number]"]');
      if (!body) return;

      var lines = [];
      if (orderNumber && orderNumber.value.trim()) {
        lines.push('Order number: ' + orderNumber.value.trim());
      }

      var current = body.value.replace(/^Order number:.*\n\n/s, '');
      if (lines.length) {
        body.value = lines.join('\n') + '\n\n' + current;
      }
    });
  }

  var RECENTLY_VIEWED_KEY = 'merenlo:recently-viewed';

  if (!customElements.get('product-recommendations')) {
    customElements.define(
      'product-recommendations',
      class ProductRecommendations extends HTMLElement {
        connectedCallback() {
          var url = this.dataset.url;
          if (!url) return;

          fetch(url)
            .then(function (response) {
              if (!response.ok) throw new Error('recommendations failed');
              return response.text();
            })
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var next = doc.querySelector('product-recommendations');
              if (next && next.innerHTML.trim().length) {
                this.innerHTML = next.innerHTML;
                initFeaturedSlider();
              }
            }.bind(this))
            .catch(function () {
              /* keep empty if recommendations unavailable */
            });
        }
      }
    );
  }

  function readRecentlyViewed() {
    try {
      var raw = window.localStorage.getItem(RECENTLY_VIEWED_KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function writeRecentlyViewed(items) {
    try {
      window.localStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify(items.slice(0, 12)));
    } catch (error) {
      /* ignore quota / private mode */
    }
  }

  function trackRecentlyViewedProduct() {
    var node = document.querySelector('[data-recently-viewed-product]');
    if (!node) return;

    var product;
    try {
      product = JSON.parse(node.textContent);
    } catch (error) {
      return;
    }
    if (!product || !product.handle) return;

    var items = readRecentlyViewed().filter(function (item) {
      return item && item.handle && item.handle !== product.handle;
    });
    items.unshift(product);
    writeRecentlyViewed(items);
  }

  function renderRecentlyViewed() {
    var section = document.querySelector('[data-recently-viewed]');
    if (!section) return;

    var grid = section.querySelector('[data-recently-viewed-grid]');
    if (!grid) return;

    var currentHandle = section.getAttribute('data-current-handle') || '';
    var limit = parseInt(section.getAttribute('data-limit') || '4', 10) || 4;
    var items = readRecentlyViewed()
      .filter(function (item) {
        return item && item.handle && item.handle !== currentHandle && item.url;
      })
      .slice(0, limit);

    if (!items.length) {
      section.hidden = true;
      grid.innerHTML = '';
      return;
    }

    grid.innerHTML = items
      .map(function (item) {
        var title = String(item.title || '').replace(/</g, '&lt;').replace(/>/g, '&gt;');
        var price = String(item.price || '').replace(/</g, '&lt;').replace(/>/g, '&gt;');
        var alt = String(item.alt || item.title || '').replace(/"/g, '&quot;');
        var image = item.image
          ? '<img src="' +
            String(item.image).replace(/"/g, '&quot;') +
            '" alt="' +
            alt +
            '" width="400" height="533" loading="lazy">'
          : '<span class="pdp-recent__media-empty" aria-hidden="true"></span>';

        return (
          '<article class="pdp-recent__item">' +
          '<a class="pdp-recent__card" href="' +
          String(item.url).replace(/"/g, '&quot;') +
          '">' +
          '<div class="pdp-recent__media">' +
          image +
          '</div>' +
          '<h3 class="pdp-recent__title">' +
          title +
          '</h3>' +
          (price ? '<p class="pdp-recent__price">' + price + '</p>' : '') +
          '</a>' +
          '</article>'
        );
      })
      .join('');

    section.hidden = false;
  }

  function initRecentlyViewed() {
    trackRecentlyViewedProduct();
    renderRecentlyViewed();
  }

  function initPdpShippingBar() {
    document.querySelectorAll('[data-pdp-shipping-bar]').forEach(function (bar) {
      var dateNode = bar.querySelector('[data-ship-date]');
      if (!dateNode || dateNode.dataset.ready === 'true') return;
      dateNode.dataset.ready = 'true';

      var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

      // Show a calendar date range for the 1–3 business-day processing window,
      // without exposing "business days" on the PDP (policy still has the detail).
      function addBusinessDays(fromDate, count) {
        var date = new Date(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate());
        var added = 0;
        while (added < count) {
          date.setDate(date.getDate() + 1);
          var weekday = date.getDay();
          if (weekday !== 0 && weekday !== 6) added += 1;
        }
        return date;
      }

      function formatDayMonth(date) {
        return date.getDate() + ' ' + months[date.getMonth()];
      }

      var today = new Date();
      var start = addBusinessDays(today, 1);
      var end = addBusinessDays(today, 3);

      if (start.getMonth() === end.getMonth()) {
        dateNode.textContent = start.getDate() + '–' + end.getDate() + ' ' + months[end.getMonth()];
      } else {
        dateNode.textContent = formatDayMonth(start) + ' – ' + formatDayMonth(end);
      }
    });
  }

  function init() {
    initMenu();
    initSearch();
    initGallery();
    initProductForm();
    initStickyAtc();
    initSizeGuideModal();
    initCategoryNav();
    initFeaturedSlider();
    initScrollReveal();
    initModalEscape();
    initHeaderScroll();
    initHeaderNav();
    initContactForm();
    initCookiePreferences();
    initCartNotice();
    initCartDrawer();
    initQuickAdd();
    initRecentlyViewed();
    initPdpShippingBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    initScrollReveal();
    initFeaturedSlider();
    initHeaderNav();
    initContactForm();
    initCookiePreferences();
    initGallery();
    initProductForm();
    initStickyAtc();
    initSizeGuideModal();
    initCartNotice();
    initCartDrawer();
    initQuickAdd();
    initRecentlyViewed();
    initPdpShippingBar();
  });
})();
